const clubRoutes = {
	cargos: {
		path: '/cargos',
		name: 'Cargos',
		component: () => import('@/views/Cargos.vue'),
		meta: { title: 'Cargos' }
	},
	suscripciones: {
		path: '/suscripciones',
		name: 'Suscripciones',
		component: () => import('@/views/Suscripciones.vue'),
		meta: { title: 'Suscripciones' }
	},
	suscripcionesPausadas: {
		path: '/suscripciones-pausadas',
		name: 'SuscripcionesPausadas',
		component: () => import('@/views/SuscripcionesPausadas.vue'),
		meta: { title: 'Suscripciones Pausadas' }
	},
	suscritores: {
		path: '/suscritores',
		name: 'Suscritores',
		component: () => import('@/views/Suscritores.vue'),
		meta: { title: 'Suscritores' }
	},
	cancelaciones: {
		path: '/cancelaciones',
		name: 'Cancelaciones',
		component: () => import('@/views/Cancelaciones.vue'),
		meta: { title: 'Cancelaciones' }
	},
	prospectos: {
		path: '/prospectos',
		name: 'Prospectos',
		component: () => import('@/views/Prospectos.vue'),
		meta: { title: 'Prospectos' }
	},
	experienciasRetail: {
		path: '/experiencias-retail',
		name: 'ExperienciasRetail',
		component: () => import('@/views/Experiencias.vue'),
		meta: { title: 'Experiencias' }
	},
	experiencias: {
		path: '/experiencias',
		name: 'Experiencias',
		component: () => import('@/views/Experiencias.vue'),
		meta: { title: 'Experiencias' }
	},
	incentivos: {
		path: '/incentivos',
		name: 'Incentivos',
		component: () => import('@/views/Incentivos.vue'),
		meta: { title: 'Incentivos' }
	},
	incentivo: {
		path: '/incentivo/:id?',
		name: 'Incentivo',
		component: () => import('@/views/Incentivo.vue'),
		meta: { title: 'Incentivo' }
	},
	beneficios: {
		path: '/beneficios',
		name: 'Beneficios',
		component: () => import('@/views/Beneficios.vue'),
		meta: { title: 'Beneficios' }
	},
	beneficio: {
		path: '/beneficio/:id?',
		name: 'Beneficio',
		component: () => import('@/views/Beneficio.vue'),
		meta: { title: 'Beneficio' }
	},
	multipleSubscriptions: {
		path: '/multiple-subscriptions',
		name: 'MultipleSubscriptions',
		component: () => import('@/views/MultipleSubscriptions.vue'),
		meta: { title: 'Múltiples Suscripciones' }
	},
	customerJourney: {
		path: '/customer-journey',
		name: 'CustomerJourney',
		component: () => import('@/views/CustomerJourney.vue'),
		meta: { title: 'Customer Journey' }
	},
	postTasting: {
		path: '/post-tasting/:id',
		name: 'PostTasting',
		component: () => import('@/views/PostTasting.vue'),
		meta: { title: 'Post-Tasting' }
	},
	postTastingMetrics: {
		path: '/post-tasting-metrics',
		name: 'PostTastingMetrics',
		component: () => import('@/views/PostTastingMetrics.vue'),
		meta: { title: 'Métricas Post-Experiencia' }
	},
	encuesta: {
		path: '/encuesta/:id',
		name: 'Encuesta',
		component: () => import('@/views/Encuesta.vue'),
		meta: { title: 'Encuesta' }
	},
	encuestaExitosa: {
		path: '/encuesta-exitosa',
		name: 'EncuestaExitosa',
		component: () => import('@/views/EncuestaExitosa.vue'),
		meta: { title: 'Gracias' }
	},
	encuestasAdmin: {
		path: '/encuestas-admin',
		name: 'EncuestasAdmin',
		component: () => import('@/views/Encuestas_Admin.vue'),
		meta: { title: 'Administrar Encuestas' }
	}
}

export default clubRoutes
